import moment from 'moment';

const initialState = () => ({
  customer: {},
  hub: {},
  hvac: {},
  sensors: [],
  graphData: [],
  deviceStatus: [],
  lastSensorReadings: {},
  log: {},
  moreInfo: {},
  memberUids: [],
  sensorTimepointData: [],
  sensorPayloadData: {},
  payloadDates: [],
  date: 60,
  activeTab: 'status',
  currentUid: '',
  deviceData: [],
  graphToggleState: new Array(8).fill(true),
  rawBatch: {},
  rawPayload: {},
  deviceConfig: {},
  actionModalView: '',
  showActionModal: false,
  startTime: moment().subtract(1, 'days').toISOString(),
  endTime: moment().toISOString(),
  showDateError: null,
  selectedJSON: null,
  timezone: localStorage.getItem('timezonePref') ? localStorage.getItem('timezonePref') : 'utc',
  timezoneFormat: localStorage.getItem('timezoneFormat') ? Number(localStorage.getItem('timezoneFormat')) : 12,
  deviceStatusTableHeaders: [
    {
      text: 'Serial Number',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'serialNumber',
    }, {
      text: 'Label',
      align: 'start',
      sortable: true,
      filterable: false,
      value: 'label',
    }, {
      text: 'Type',
      align: 'start',
      sortable: true,
      filterable: false,
      value: 'type',
    }, {
      text: 'Battery',
      align: 'start',
      sortable: true,
      filterable: false,
      value: 'battery',
    }, {
      text: 'Ratio',
      align: 'start',
      sortable: true,
      filterable: false,
      value: 'sensorRatio',
    }, {
      text: 'Last Signal',
      align: 'start',
      sortable: true,
      filterable: false,
      value: 'lastSignalTime',
    }, {
      text: 'Last Update',
      align: 'start',
      sortable: true,
      filterable: false,
      value: 'lastUpdateTime',
    }, {
      text: 'Firmware',
      align: 'start',
      sortable: true,
      filterable: false,
      value: 'fwVersion',
    },
  ],
  commands: [],
  filterTemp: [],
  comfortTemp: [],
  atticTemp: [],
  filterPressure: [],
  outsideTemp: [],
  humidity: [],
  datetime: [],
  cyclePayloads: [],
  startOfDay: '',
  endOfDay: '',
  devices: {},
  allSupplySerialCycles: {},
  selectedSupplySerial: '',
  showOnlyValid: true,
  showFwView: false,
  showCycle: true,
  loadingCycleChart: false,
  toggleMode: true,
  loadingDeviceDetail: false,
  processingMigration: false,
  loadingGraphData: false,
  loadingRawDataTab: false,
  loadingSensorDataTab: false,
});

export default initialState;
